import { Box, Paper, Stack, experimentalStyled as styled } from "@mui/material"
import IprIcon2 from "./IprIcon2"
import StageAddIcon from "./stageAddIcon"
import TriangleIconForIpr from "./triangleIconForIpr"

const StageItemForIpr = (props) => {
  const ButtonItem = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }))

  const redColor = "#FF5E63"
  const curStageArchQuick3Index =
    props.archType === 0 ? props.upQuick3Index : props.downQuick3Index
  const isIprNode = props.isNodeContains(props.item.nodeTypes, 1)
  const firstCollisionStage = props.firstCollisionStage //(props.archType === 0 ? props.upIprWaringIndex : props.downIprWaringIndex)
  console.info(
    "props.iprDragFromStep:",
    props.iprDragFromStep,
    ", props.iprDragToStep:",
    props.iprDragToStep,
  )

  const topAreaHeight = 12
  const addMargin = 3
  const triangleMargin = 2
  const triangleHeight = 5
  const stageWidth = props.singleStageWidth

  return (
    <div
      style={{
        width:
          props.actualStageWidth +
          (props.countOfFoldGroup > 1 ? 0 : props.stageDiv),
        height:
          topAreaHeight +
          addMargin +
          props.singleStageHeight +
          triangleMargin +
          triangleHeight,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
      }}
    >
      <Stack direction="row" spacing={0}>
        <div
          style={{
            width: stageWidth,
            height:
              topAreaHeight +
              addMargin +
              props.singleStageHeight +
              triangleMargin +
              triangleHeight,
            position: "relative",
          }}
        >
          {props.archType === 1 ? (
            <TriangleIconForIpr
              position={"absolute"}
              left={stageWidth + 2.5}
              top={4}
              direction="down"
              visibility={
                props.index === props.stageCurrentStep ? "" : "hidden"
              }
            />
          ) : (
            <></>
          )}

          {props.archType === 0 &&
          props.index !== props.itemArray.length - 1 &&
          !isIprNode &&
          props.viewEdit &&
          props.index >= curStageArchQuick3Index &&
          props.index === props.stageCurrentStep &&
          props.iprDragToStep !== props.index ? (
            <StageAddIcon
              zIndex={2}
              position={"absolute"}
              left={stageWidth + 2}
              top={0}
              status={"add"}
              onClick={props.addNodeHandler}
            />
          ) : (
            <></>
          )}
          {props.archType === 0 &&
          props.index !== props.itemArray.length - 1 &&
          isIprNode &&
          props.viewEdit &&
          props.index >= curStageArchQuick3Index &&
          props.index === props.stageCurrentStep ? (
            <StageAddIcon
              zIndex={2}
              position={"absolute"}
              left={stageWidth + 4 + 12}
              top={1}
              status={"del"}
              onClick={props.deleteNodeHandler}
            />
          ) : (
            <></>
          )}
          {props.archType === 0 &&
          props.index !== props.itemArray.length - 1 &&
          (isIprNode ||
            props.iprDragFromStep === props.index ||
            props.iprDragToStep === props.index) &&
          props.viewEdit ? (
            <IprIcon2
              opacity={
                props.iprDragFromStep !== -1 &&
                props.iprDragFromStep === props.index &&
                props.iprDragToStep !== props.index
                  ? 0.01
                  : 1.0
              }
              zIndex={2}
              position={"absolute"}
              left={stageWidth - 1 - 2}
              top={0}
              direction="down"
              index={props.index}
              iprPositionXChanged={props.iprPositionXChanged}
              iprDragStoped={props.iprDragStoped}
            />
          ) : (
            <></>
          )}

          <ButtonItem
            sx={{
              width: stageWidth,
              height: props.singleStageHeight,
              position: "absolute",
              top:
                props.archType === 0
                  ? topAreaHeight + addMargin
                  : triangleHeight + triangleMargin,
              // alignItems: 'center',
              // justifyContent: 'center',
              border:
                firstCollisionStage[props.index] === 1
                  ? redColor
                  : props.index <= curStageArchQuick3Index
                  ? "solid 1px #b1b1b1"
                  : "solid 1px #414141",
              color: "black",
              backgroundColor:
                firstCollisionStage[props.index] === 1 ? redColor : "white",
              fontSize: 14,
              userSelect: "none",
              zIndex: 0,
            }}
            onClick={() => {
              props.stageButtonClickHandle(
                props.item,
                props.index,
                props.itemArray,
              )
            }}
          >
            <Box
              sx={{
                width: 6,
                height: 6,
                backgroundColor: "transparent",
                borderRadius: 3,
                margin: "0 auto",
                position: "absolute",
                left: (stageWidth - 2) / 2 - 6 / 2,
                top:
                  props.archType === 0
                    ? 2
                    : props.singleStageHeight - 3 - 6 - 1,
              }}
            ></Box>

            <div
              style={{
                userSelect: "none",
                color: props.isNodeContains(props.item.nodeTypes, 14)
                  ? "#FF6363"
                  : "transparent",
                width: 6,
                height: 12,
                position: "absolute",
                left: stageWidth - 6 - 2,
                top: props.archType === 0 ? 0 : props.singleStageHeight - 13,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 12,
              }}
            >
              P{/* <b>P</b> */}
            </div>

            <span
              style={{
                userSelect: "none",
                width: stageWidth - 2,
                height: 16,
                fontSize: 15,
                position: "absolute",
                left: 0,
                bottom:
                  props.archType === 0
                    ? 1
                    : props.singleStageHeight - 2 - 16 - 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color:
                  firstCollisionStage[props.index] === 1
                    ? "white"
                    : props.index <= curStageArchQuick3Index
                    ? "gray"
                    : "black",
              }}
            >
              {props.item.indexStr}
            </span>
          </ButtonItem>

          {props.archType === 0 ? (
            <TriangleIconForIpr
              position={"absolute"}
              left={stageWidth + 2.5}
              top={
                topAreaHeight +
                addMargin +
                props.singleStageHeight +
                triangleMargin -
                3
              }
              direction="up"
              visibility={
                props.index === props.stageCurrentStep ? "" : "hidden"
              }
            />
          ) : (
            <></>
          )}

          {props.archType === 1 &&
          props.index !== props.itemArray.length - 1 &&
          !isIprNode &&
          props.viewEdit &&
          props.index >= curStageArchQuick3Index &&
          props.index === props.stageCurrentStep &&
          props.iprDragToStep !== props.index ? (
            <StageAddIcon
              zIndex={2}
              position={"absolute"}
              left={stageWidth + 2}
              top={
                triangleHeight +
                addMargin +
                props.singleStageHeight +
                triangleMargin
              }
              status={"add"}
              onClick={props.addNodeHandler}
            />
          ) : (
            <></>
          )}
          {props.archType === 1 &&
          props.index !== props.itemArray.length - 1 &&
          (isIprNode ||
            props.iprDragFromStep === props.index ||
            props.iprDragToStep === props.index) &&
          props.viewEdit ? (
            <IprIcon2
              opacity={
                props.iprDragFromStep !== -1 &&
                props.iprDragFromStep === props.index &&
                props.iprDragToStep !== props.index
                  ? 0.01
                  : 1.0
              }
              zIndex={2}
              position={"absolute"}
              left={stageWidth - 1 - 2}
              top={
                triangleHeight +
                addMargin +
                props.singleStageHeight +
                triangleMargin -
                3
              }
              direction="up"
              index={props.index}
              iprPositionXChanged={props.iprPositionXChanged}
              iprDragStoped={props.iprDragStoped}
            />
          ) : (
            <></>
          )}
          {props.archType === 1 &&
          props.index !== props.itemArray.length - 1 &&
          isIprNode &&
          props.viewEdit &&
          props.index >= curStageArchQuick3Index &&
          props.index === props.stageCurrentStep ? (
            <StageAddIcon
              zIndex={2}
              position={"absolute"}
              left={stageWidth + 4 + 12}
              top={
                triangleHeight +
                addMargin +
                props.singleStageHeight +
                triangleMargin
              }
              status={"del"}
              onClick={props.deleteNodeHandler}
            />
          ) : (
            <></>
          )}
        </div>

        <Box
          sx={{
            width: props.countOfFoldGroup > 1 ? 0 : props.stageDiv,
            height: 1,
          }}
        >
          {/* {props.archType === 0 ? <IprIcon visibility={isIprNode ? "" : "hidden"} position={"relative"} left={props.stageDiv / 2} top={topAreaHeight + addMargin - 5} direction="up"/> : <IprIcon visibility={isIprNode ? "" : "hidden"} position={"relative"} left={props.stageDiv / 2} top={triangleHeight + addMargin} direction="down"/>} */}
        </Box>
      </Stack>
    </div>
  )
}

export default StageItemForIpr
